import type { Strings } from "../i18n/strings";

interface Props {
  t: Strings;
  stepBack: string; // AI step_back. 없으면 정적 폴백(os_step).
  onClose: () => void;
}

// ⑨ 범위 밖 (off_scope): 순수 슬픔·우울. 점수·리포트·카드 없음.
// 종이는 똑같이 버려진다. 위로 단어 0 — 버려주는 행동이 위로.
export default function BowOut({ t, stepBack, onClose }: Props) {
  const step = stepBack.trim() || t.osStep;
  return (
    <div className="screen bowout">
      <div className="rep-header">
        <button className="navbtn" onClick={onClose}>
          ✕ {t.close}
        </button>
      </div>
      <div className="bowout-body">
        <div className="toss-glyph">📄 → 🗑️</div>
        {step.split("\n").map((line, i) => (
          <p key={i} className="bowout-line">
            {line}
          </p>
        ))}
        <p className="bowout-throw">{t.osThrow}</p>
      </div>
    </div>
  );
}
